import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'nalco-cleanup',
    templateUrl: './cleanup.component.html',
    styleUrls: ['./cleanup.component.css'],
    standalone: false
})
export class CleanupComponent implements OnInit {

  ngOnInit() {
    console.log('Cleaning up everything');
    // Unregister all service workers
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
          console.log('Un registering service worker:', registration);
          registration.unregister();
        }
      });
    }

    // Delete all caches
    if ('caches' in window) {
      caches.keys().then(function (names) {
        for (let name of names) {
          console.log('Deleting cache:', name);
          caches.delete(name);
        }
      });
    }

    // Delete all cookies for all domain levels
    document.cookie.split(';').forEach(function (c) {
      var d = window.location.hostname.split('.');
      while (d.length > 0) {
        var cookieBase = encodeURIComponent(c.split('=')[0].trim()) +
          '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=' + d.join('.') + ';path=; Secure';
        console.log('Deleting cookie:', cookieBase);
        document.cookie = cookieBase + '/';
        document.cookie = cookieBase;
        d.shift();
      }
    });

    // Clear localStorage and sessionStorage
    try { localStorage.clear(); } catch (e) { }
    try { sessionStorage.clear(); } catch (e) { }

    // Redirect back after cleanup
    // setTimeout(function () {
    //   var params = new URLSearchParams(window.location.search);
    //   var returnUrl = params.get('return') || '/';
    //   window.location.href = returnUrl;
    // }, 300);
  }
}
